import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()
export const modalConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '第 三 方',
      clearable: true,
      multiple: true,
      placeholder: '请选择第三方'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '统计日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      },
      rules: {required: true, message: '统计日期不能为空', trigger: 'blur'}
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
